export const Api = '/kzjt'
export const Files = '/kzjt/modules/file/s/'
export const Files1 = '/kzjt/modules/file/s/'

export const pointRemarkMap = {
  1: '签到',
  2: '课程分享',
  3: '注册邀请',
  4: '回答提问',
  5: '提交培训反馈',
  6: '直播课程分享',
  7: '进直播间',
  8: '课程学习',
  9: '资料阅读',
  10: '连续签到7天',
  11: '连续签到20天'
}



// WEBPACK FOOTER //
// ./src/common/config.js